<template>
  <PopupForm
    title="Trigger Order Event"
    button="Trigger"
    :show="show"
    @close="emit('close')"
    @confirm="submit()"
  >
    <div class="input-group col-span-12 sm:col-span-4 mb-4">
      <select
        v-model="form.event"
        name="event"
      >
        <option :value="null">Select Event</option>
        <template v-for="(label, key) in eventOptions">
          <option :value="key">
            {{ label }}
          </option>
        </template>
      </select>
      <p
        v-if="getErrors('event')"
        class="input-error"
      >
        {{ getErrors('event') }}
      </p>
    </div>
  </PopupForm>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useForm } from '@inertiajs/vue3'
import PopupForm from '@/Components/Forms/PopupForm'
import { getHeadersWithToken } from '@/utils/http'
import _ from 'lodash'

const emit = defineEmits(['close'])

const props = defineProps({
  /**
   * If true we display the form
   */
  show: {
    type: Boolean,
    default: false
  },
  order: {
    type: Object,
    required: true
  },
  /**
   * Events to fire
   */
  eventOptions: {
    type: Array,
    default: () => []
  }
})

const form = useForm({
  event: null
})

const submitting = ref(false)

const submit = () => {
  if (submitting.value) {
    return
  }

  submitting.value = true

  form.post(route('orders.events.store', { order: props.order.id }), {
    // errorBag: 'createTransfer',
    onSuccess: (response) => {
      form.reset()
      emit('close')
    },
    onFinish: (response) => {
      submitting.value = false
    }
  })
}

const getErrors = (field) => {
  let errors = form.errors || {}
  return field in errors ? errors[field] : ''
}
</script>
